<script setup>
import { slider } from '@phx-styleguides/iwc';
import { onMounted, ref } from 'vue';
import { PhxsgIcon } from '@sg/src/View/Components/Atoms/Icon';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';
import PictureLazy from '@maison/components/common/PictureLazy.vue';

defineProps({
  id: {
    type: String,
    required: true,
  },
  slides: {
    type: Array,
    required: true,
  },
});

const sliderRef = ref(null);
const sliderInstance = ref(null);

onMounted(() => {
  if (sliderRef.value) {
    sliderInstance.value = slider(sliderRef.value, {
      threshold: 5,
      slidesPerView: 'auto',
      mousewheel: {
        forceToAxis: true,
      },
    });
  }
});
</script>

<template>
  <div
    :id="`${id}-slider`"
    ref="sliderRef"
    class="slider slider--collection"
    role="group"
    aria-roledescription="carousel"
    :aria-label="$t('Accessibility.collectionSlider.ariaLabel')"
  >
    <div class="slider__nav slider__nav--prev">
      <PhxsgButton icon-only size="sm">
        <template #content>
          <PhxsgIcon id="triangle-left" size="md" bidirectional />
        </template>
      </PhxsgButton>
    </div>

    <div class="slider__body" aria-atomic="false" aria-live="polite">
      <div
        v-for="(slide, i) in slides"
        :key="`cluster-slide-${id}-${i}`"
        class="slider__item"
        role="tabpanel"
        :aria-labelledby="`pagination-${i}`"
      >
        <a class="picture picture--actionable" :href="slide.data.href">
          <picture-lazy v-bind="slide.data" />
        </a>
      </div>
    </div>

    <div class="slider__nav slider__nav--next">
      <PhxsgButton icon-only size="sm">
        <template #content>
          <PhxsgIcon id="triangle-right" size="md" bidirectional />
        </template>
      </PhxsgButton>
    </div>

    <div class="slider__footer">
      <div class="slider__scrollbar"></div>
    </div>
  </div>
</template>
